import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShuffle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconShuffle"><Path d="M2.75 18.1875H3.56345C4.35878 18.1875 5.12157 17.8717 5.68412 17.3095L15.3714 7.62804C15.934 7.06582 16.6968 6.75 17.4921 6.75H20.5M2.75 5.75H3.50736C4.30301 5.75 5.06607 6.06607 5.62868 6.62868L8.5 9.5M20.5 17.1562H17.3688C16.5643 17.1562 15.7934 16.8331 15.2294 16.2593L13.5 14.5M18.25 3.75L21.25 6.75L18.25 9.75M18.1667 14.0625L21.25 17.1562L18.1667 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconShuffle;
